import { render, staticRenderFns } from "./EnrollmentCard.vue?vue&type=template&id=4bb19212&scoped=true&"
import script from "./EnrollmentCard.vue?vue&type=script&lang=ts&"
export * from "./EnrollmentCard.vue?vue&type=script&lang=ts&"
import style0 from "./EnrollmentCard.vue?vue&type=style&index=0&id=4bb19212&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb19212",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VBtn,VDivider})
